import React from 'react'
import PropTypes from 'prop-types'

import { Button } from './styles'

export default function ComponentButton ({ children, ...props }) {
  return <Button type="button" {...props}>{children}</Button>
}

ComponentButton.propTypes = {
  children: PropTypes.any
}
